<template>
    <div :id="id" class="modal" :class="{ show: is_open }">
        <div :class="`modal-dialog ${dialogClass}`" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="`${id}ModalLabel`">
                        <slot name="title"></slot>
                    </h5>
                    <button
                        type="button"
                        class="close"
                        @click="cancel"
                        :aria-label="t('confirm-close')"
                    ><Icon icon-class="ui-x-close" size="4" /></button>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        ref="btnCancel"
                        class="btn btn-secondary"
                        @click="cancel"
                    >
                        <slot name="cancel">{{ t('confirm-cancel') }}</slot>
                    </button>
                    <button
                        :disabled="disabled"
                        type="button"
                        ref="btnConfirm"
                        :class="'btn ' + buttonClass"
                        @click="confirm"
                    >
                        <slot name="confirm">{{ t('confirm-confirm') }}</slot>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from "../../components/icon/icon";
export default {
    name: "confirm",
    components: { Icon },
    props: {
        id: String,
        dialogClass: String,
        buttonClass: {
            type: String,
            default: "btn-primary",
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            is_open: false,
        };
    },
    mounted: function () {
        this.is_open = false;
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        open: function () {
            this.is_open = true;
            window.setTimeout(() => {
                if (this.$refs.btnConfirm) {
                    this.$refs.btnConfirm.focus();
                }
            }, 200);
        },
        close: function () {
            this.is_open = false;
        },
        confirm: function () {
            this.$emit("confirm");
            this.close();
        },
        cancel: function () {
            this.$emit("cancel");
            this.close();
        },
        isOpen: function () {
            return this.is_open;
        },
    },
};
</script>
<style scoped lang="scss">
.modal {
    background: rgba(0, 0, 0, 0.25);
    display: block;
    visibility: hidden;
    opacity: 0;
    transition: all 0.3s;
    .modal-dialog {
        transform: translateY(-80px);
        transition: all 0.3s;
    }
    &.show {
        visibility: visible;
        opacity: 1;
        .modal-dialog {
            transform: translateY(0);
        }
    }
}
</style>
